import React from 'react';
import Icon from '../../../components/AppIcon';

const ValuesSection = () => {
  const values = [
    {
      icon: "Target",
      title: "Client-Centric Approach",
      description: "Every decision we make starts with understanding our clients' needs. We don't just deliver solutions—we build partnerships that drive mutual success and long-term growth.",
      color: "from-blue-500 to-blue-600"
    },
    {
      icon: "Lightbulb",
      title: "Innovation & Excellence",
      description: "We stay ahead of technology trends and creative practices, continuously learning and adapting to deliver cutting-edge solutions that give our clients competitive advantages.",
      color: "from-purple-500 to-purple-600"
    },
    {
      icon: "Shield",
      title: "Trust & Transparency",
      description: "We build relationships on honesty and clear communication. Our clients always know what to expect, with transparent processes and regular updates throughout every project.",
      color: "from-green-500 to-green-600"
    },
    {
      icon: "Users",
      title: "Collaborative Spirit",
      description: "We believe the best results come from working together. Our team collaborates internally and with clients to ensure every perspective is heard and valued.",
      color: "from-orange-500 to-orange-600"
    },
    {
      icon: "Zap",
      title: "Agility & Responsiveness",
      description: "In the fast-paced digital world, speed matters. We respond quickly to client needs, adapt to changing requirements, and deliver solutions with efficiency and precision.",
      color: "from-red-500 to-red-600"
    },
    {
      icon: "Award",
      title: "Quality Without Compromise",
      description: "We never cut corners. Every project receives the same meticulous attention to detail, whether it's a small branding update or a complete digital transformation.",
      color: "from-teal-500 to-teal-600"
    }
  ];

  return (
    <section className="bg-gradient-to-br from-[#2642B2] via-indigo-900 to-slate-900 text-whiten py-12 md:py-16 lg:py-20 px-4 md:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-8 md:mb-12 lg:mb-16">
          <div className="inline-flex items-center gap-2 bg-primary/10 px-4 py-2 rounded-full mb-4">
            <Icon name="Heart" size={18} color="var(--color-primary)" />
            <span className="text-white text-sm font-medium">Our Values</span>
          </div>
          
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-white mb-4">
            The Principles That Guide Us
          </h2>
          
          <p className="text-sm md:text-base lg:text-lg text-white max-w-3xl mx-auto">
            Our core values shape every interaction, decision, and solution we deliver. They're not just words on a page—they're the foundation of how we work.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {values?.map((value, index) => (
            <div 
              key={index}
              className="bg-card rounded-2xl p-6 md:p-8 shadow-md hover:shadow-xl transition-all duration-300 group"
            >
              <div className={`w-14 h-14 md:w-16 md:h-16 rounded-2xl bg-gradient-to-br ${value?.color} flex items-center justify-center mb-4 md:mb-6 group-hover:scale-110 transition-transform duration-300`}>
                <Icon name={value?.icon} size={28} color="#ffffff" />
              </div>
              
              <h3 className="text-lg md:text-xl font-bold text-foreground mb-3">
                {value?.title}
              </h3>
              
              <p className="text-sm md:text-base text-text-secondary leading-relaxed">
                {value?.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ValuesSection;